import { render, staticRenderFns } from "./HistoryReviewDialog.vue?vue&type=template&id=b466782a&scoped=true&"
import script from "./HistoryReviewDialog.vue?vue&type=script&lang=js&"
export * from "./HistoryReviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./HistoryReviewDialog.vue?vue&type=style&index=0&id=b466782a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b466782a",
  null
  
)

export default component.exports